import { http } from '@/services/AxiosService'
import store from '@/store'

const actions = {
  async fetchCurrencyCourse(ctx) {
    const res = await fetch(
      'https://api.privatbank.ua/p24api/pubinfo?json&exchange&coursid=5'
    )
    const data = await res.json()
    ctx.commit('setUsdCourse', parseFloat(data[0].buy).toFixed(1))
  },
  setGlobalCurrency(ctx, value) {
    ctx.commit('setGlobalCurrency', value)

    const usdCourse = ctx.getters.getUsdCourse
    const currency = ctx.getters.getGlobalCurrency
    const start = ctx.getters.getFlatsFilterParams.price.start
    const end = ctx.getters.getFlatsFilterParams.price.end
    const price = {
      start: currency === 'usd' ? start : start * usdCourse,
      end: currency === 'usd' ? end : end * usdCourse,
    }
    ctx.commit('setConvertedPriceFilter', price)
  },
}

const mutations = {
  setGlobalCurrency(state, value) {
    state.selectedGlobalCurrency = value
  },
  setUsdCourse(state, value) {
    state.usdCourse = value
  },
}
const getters = {
  getUsdCourse(state) {
    return state.usdCourse
  },
  getGlobalCurrency(state) {
    return state.selectedGlobalCurrency
  },
}
const state = {
  selectedGlobalCurrency: 'usd',
  usdCourse: 40,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
